import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ui-maintenance-language"
}
const _hoisted_2 = {
  key: 5,
  class: "maintenance-checking"
}
const _hoisted_3 = {
  key: 6,
  class: "maintenance-test-banner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OperationFeedbackHost = _resolveComponent("OperationFeedbackHost")!
  const _component_LanguageSelect = _resolveComponent("LanguageSelect")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_MaintenanceScreen = _resolveComponent("MaintenanceScreen")!
  const _component_MaintenanceTesterLogin = _resolveComponent("MaintenanceTesterLogin")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_config_provider, {
      locale: _ctx.locale,
      direction: _ctx.uiDirection
    }, {
      default: _withCtx(() => [
        _createVNode(_component_OperationFeedbackHost),
        (!_ctx.maintenanceReady || _ctx.maintenanceConfig.enabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_LanguageSelect)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isMaintenanceAccessRoute)
          ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
          : (_ctx.maintenanceReady && _ctx.maintenanceBlocked && !_ctx.testerLogin)
            ? (_openBlock(), _createBlock(_component_MaintenanceScreen, {
                key: 2,
                config: _ctx.maintenanceConfig,
                checking: _ctx.maintenanceChecking,
                onRefresh: _ctx.refreshMaintenance,
                onTesterLogin: _ctx.beginTesterLogin
              }, null, 8, ["config", "checking", "onRefresh", "onTesterLogin"]))
            : (_ctx.maintenanceReady && _ctx.maintenanceBlocked && _ctx.testerLogin)
              ? (_openBlock(), _createBlock(_component_MaintenanceTesterLogin, {
                  key: 3,
                  checking: _ctx.testerChecking,
                  onAuthenticated: _ctx.verifyTesterLogin,
                  onCancel: _ctx.exitMaintenanceTest
                }, null, 8, ["checking", "onAuthenticated", "onCancel"]))
              : (_ctx.maintenanceReady)
                ? (_openBlock(), _createBlock(_component_router_view, { key: 4 }))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, "正在检查系统状态...")),
        (_ctx.testerAllowed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createTextVNode("维护测试中 "),
              _createVNode(_component_a_button, {
                size: "small",
                onClick: _ctx.exitMaintenanceTest
              }, {
                default: _withCtx(() => [
                  _createTextVNode("退出维护测试")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["locale", "direction"])
  ]))
}